import { useEffect } from "react";
import { FlexGrid, Typography, useThemeProvider, Card, Skeleton, useDialog } from '@albo-ui/core'
import { CustomerVipProps } from "./types";
import { useVipTable } from "./hooks/useVipTable";
import { useVipManager } from "./hooks/useVipManager";
import DataTable from "react-data-table-component";
import { customStyles2 } from "../../../util/TableStyles"
import { noDataComponent } from "../../../util/DataObject"
import { CustomerVipAdd } from "../../modals/customer-vip/CustomerVipAdd";
import SailingIcon from '@mui/icons-material/Sailing';
import { Box, Tab, Tabs } from '@mui/material';
import CustomPagination from '../../elements/CustomPagination';
import CustomSearchBar from "../../elements/SearchBar/CustomSearchBar";

export const CustomerVipList = ({ changeAlert, changeLoader, sectionData, catalog }: CustomerVipProps) => {
    const { theme } = useThemeProvider();
    const { getCustomerData, handleGet } = useVipManager(changeAlert)
    const { columns, data, loading: loadingTable, tabActive, tabs, pagination, changeTab, saveData, getData, changePage, handleChangeRowsPerPage, onHandleSearch } = useVipTable(changeAlert)
    const dialogProps = useDialog();

    const onOpenCustomerAdd = () => {
        dialogProps.openDialog();
    };
    const onCloseCustomer = () => {
        dialogProps.onClose();
    };

    const searchOptions = [
        { key: "uuid", label: "UUID" },
        { key: "email", label: "Email" },
    ];

    useEffect(() => {
        changeLoader(loadingTable);
        if (!loadingTable) {
            handleGet(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingTable]);

    useEffect(() => {
        saveData(sectionData);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        if (getCustomerData) {
            getData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getCustomerData]);
    
    return (
        <Card padding={4} flexDirection="column" fullWidth fullHeight alignItems="stretch" justifyContent="space-between" style={{ borderColor: theme.colors.manatee }}> 
            <FlexGrid container fullWidth justify="space-between" style={{ marginBottom: 25, display: "flex" }}>
                <FlexGrid item justify="space-between" style={{ width: "50%" }}>
                    <Typography variant="h2" style={{display: "inline-flex", alignItems: "center", fontSize: "1.2rem"}}>
                        <SailingIcon sx={{ marginRight: 1 }}/> Clientes VIP
                    </Typography>
                </FlexGrid>

                <FlexGrid item spacing={2} fullWidth>
                    <CustomSearchBar 
                        onConfirm={onHandleSearch} 
                        select={{
                            options: searchOptions,
                            text: "Búsqueda por:"
                        }}
                        field={true}
                        button={{
                            width: 300,
                            onHandle: onOpenCustomerAdd,
                            text: `Agregar ${tabActive === "worker" ? "Worker" : "Cliente"}`
                        }}
                    />
                </FlexGrid>
            </FlexGrid>
                    
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }} my={1} >
                <Tabs value={tabActive} indicatorColor='secondary' textColor='secondary' variant='fullWidth'>
                    {tabs.map((item, index) => {
                        return <Tab key={index} label={item.title} value={item.key} onClick={changeTab.bind(this, item.key)} sx={{textTransform: 'none', fontWeight: 700, fontFamily: 'Muli,sans-serif', fontSize: 14}} />
                    })}
                </Tabs>
            </Box>

            <FlexGrid container spacing={2} >
                {
                    loadingTable ?
                        <Skeleton width="100%" height="100px" />
                        :
                        <FlexGrid fullWidth>
                        <DataTable
                            columns={columns}
                            data={data}
                            customStyles={customStyles2}
                            noDataComponent={noDataComponent}
                        />
                        <CustomPagination 
                            rows={pagination.totalDocuments}
                            page={pagination.page - 1}
                            rowsPerPage={pagination.rowsPerPage}
                            handleChangePage={changePage}
                            handleChangeRowsPerPage={handleChangeRowsPerPage}
                        />
                        </FlexGrid>

                }
            </FlexGrid>
            <CustomerVipAdd
                title={`Agregar ${tabActive === "worker" ? "worker" : "cliente"}`}
                open={dialogProps.open}
                onClose={onCloseCustomer}
                handleGet={handleGet}
                changeAlert={changeAlert}
                changeLoader={changeLoader}
                catalog={catalog}
                type={tabActive}
            />
        </Card>
    )
}

